import { Theme } from '@mui/material';

export const wsdAlertSizeNames = ['medium', 'small', 'xsmall'] as const;

export type WsdAlertSizeName = (typeof wsdAlertSizeNames)[number];

export const alertCloseButtonHeight = 15;

export const alertMinHeights = {
  medium: 54,
  small: 34,
  xsmall: 24,
};

export function alertMessageVerticalPadding(
  theme: Theme
): Record<WsdAlertSizeName, number> {
  return {
    medium: parseInt(theme.spacing(1)),
    small: parseInt(theme.spacing(0.5)),
    xsmall: 2,
  };
}

// MUI's message vertical padding is tightly coupled with the close button alignment.
// So instead of zero-ing out the padding for the message to match WSD's styles,
// we'll keep MUI's padding, and subtract it from the WSD vertical padding values
// for the parent alert container.
export function alertVerticalPadding(
  theme: Theme
): Record<WsdAlertSizeName, number> {
  return {
    medium: 17 - alertMessageVerticalPadding(theme).medium,
    small: 7 - alertMessageVerticalPadding(theme).small,
    xsmall: 4 - alertMessageVerticalPadding(theme).xsmall,
  };
}

// Returns the vertical padding needed to center a WSD style close button in an alert with a single line of text.
export function alertCloseButtonVerticalPadding(
  theme: Theme
): Record<WsdAlertSizeName, number> {
  return {
    medium: Math.ceil(
      (alertMinHeights.medium -
        alertVerticalPadding(theme).medium * 2 -
        // The action contains utilizes half of the message vertical padding.
        alertMessageVerticalPadding(theme).medium -
        alertCloseButtonHeight) /
        2
    ),
    small: Math.ceil(
      (alertMinHeights.small -
        alertVerticalPadding(theme).small * 2 -
        // The action contains utilizes half of the message vertical padding.
        alertMessageVerticalPadding(theme).small -
        alertCloseButtonHeight) /
        2
    ),
    xsmall: Math.ceil(
      (alertMinHeights.xsmall -
        alertVerticalPadding(theme).xsmall * 2 -
        // The action contains utilizes half of the message vertical padding.
        alertMessageVerticalPadding(theme).xsmall -
        alertCloseButtonHeight) /
        2
    ),
  };
}
